<template>
  <div>
    <div
      class="sub-header"
      data-test="sub-header"
    >
      Tell us what matters to you!
    </div>
    <div class="overflow-y-scroll scrollbar modal-height">
      <h5
        class="helping-text details text-base mb-4"
        data-test="helping-text"
      >
        Preferences can also be changed from the Settings tab.
      </h5>
      <AccountPreferencesForm
        data-test="account-preferences-form"
        :localPreferences="localPreferences"
        @update:localPreferences="(newPreferences) => (localPreferences = newPreferences)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useDonorStore } from '@/stores/DonorStore.js';
import AccountPreferencesForm from '@/components/settings/AccountPreferencesForm.vue';

const donorStore = useDonorStore();

let localPreferences = ref({
  categories: [],
  orgSizes: [],
  areasOfImpact: [],
});
let initialPreferences = JSON.parse(JSON.stringify(localPreferences.value));

// Watch for changes in localPreferences and call updatePreferences when changes occur
watch(
  localPreferences,
  () => {
    updatePreferences();
  },
  { deep: true },
);

const updatePreferences = () => {
  donorStore.donorPreferences.categories.selected = JSON.parse(JSON.stringify(localPreferences.value.categories));
  donorStore.donorPreferences.orgSizes.selected = JSON.parse(JSON.stringify(localPreferences.value.orgSizes));
  donorStore.donorPreferences.areasOfImpact.selected = JSON.parse(JSON.stringify(localPreferences.value.areasOfImpact));
};

onMounted(() => {
  if (donorStore.donorPreferences) {
    localPreferences.value.categories = donorStore.donorPreferences.categories.selected
      ? JSON.parse(JSON.stringify(donorStore.donorPreferences.categories.selected))
      : [];
    localPreferences.value.orgSizes = donorStore.donorPreferences.orgSizes.selected
      ? JSON.parse(JSON.stringify(donorStore.donorPreferences.orgSizes.selected))
      : [];
    localPreferences.value.areasOfImpact = donorStore.donorPreferences.areasOfImpact.selected
      ? JSON.parse(JSON.stringify(donorStore.donorPreferences.areasOfImpact.selected))
      : [];

    // Set initialPreferences with the loaded preferences
    initialPreferences = JSON.parse(JSON.stringify(localPreferences.value));
  }
});
</script>
